import React from "react";
import { StepTracker } from "component-library";
import { useStepTracking } from "shared-hooks";

interface IStepTrackingProps {
  stepNumber: number;
  updateStepNumber?: (newStepNumber: number) => void;
  disableAllSteps?: boolean;
  stepTrackingItems: { label: string }[];
}

export const StepTracking: React.FC<IStepTrackingProps> = ({
  stepNumber,
  updateStepNumber,
  disableAllSteps,
  stepTrackingItems,
}) => {
  const steps = useStepTracking({
    stepNumber,
    updateStepNumber,
    disableAllSteps,
    stepTrackingItems,
  });

  return <StepTracker items={steps} />;
};
